import { Configuration, RedirectRequest } from '@azure/msal-browser';
import { scopes } from '../models/scopes';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID!,
    authority: import.meta.env.VITE_AUTHORITY,
    redirectUri: `${window.location.origin}/response-oidc`,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const redirectRequest: RedirectRequest = {
  scopes: [
    scopes.offlineAccess,
    scopes.openid,
    scopes.profile,
  ],
};
